module.exports = __webpack_public_path__ + "media/images/athletes/1779-7ab96394238ddc40dccb9e159777d293.png";